enum DonationExtSources {
  CLASSY_SUPPORTER = 'classy',
  EVENTBRITE = 'eventbrite',
  INSTIL = 'instil',
  PLEDGE = 'pledge',
  PLEDGE_TO = 'pledge.to',
  SALESFORCE = 'salesforce',
  STRIPE = 'stripe',
  STRIPE_CUSTOMER = 'stripe_customer',
}

export default DonationExtSources;
